/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

// ==============================================================================
// Measure ads inside a Daisy iframe
// ------------------------------------------------------------------------------

window.AdMeasurer = {
	init(param) {
		if (param == null) {
			param = {};
		}

		let { format } = param;
		this.Data = { format };
		this.Dom = {};
		this.renderedData = {};

		this.loopSoon();
	},

	loopSoon() {
		requestAnimationFrame(() => this.loop());
	},

	loop() {
		// main application loop.
		// remember to keep @Data's properties simple objects, so we can use ===.
		let container = this.getContainer();
		let { width, height } = this.getSizes(container);

		this.Data.width = width;
		this.Data.height = height;

		this.render();
		this.loopSoon();
	},

	getContainer() {
		let container;
		if (this.Dom.container == null) {
			container = document.getElementById("tag_html");
			if (!container) {
				return null;
			}
			this.Dom.container = container;
		}

		return this.Dom.container;
	},

	getSizes(container) {
		if (!container) {
			return {};
		}

		// if no width or height came back, then consider them both undefined
		let width = container.offsetWidth || undefined;
		let height = container.offsetHeight || undefined;

		return { width, height };
	},

	render() {
		for (let name of Object.keys(this.Data || {})) {
			let value = this.Data[name];

			if (value === this.renderedData[name]) {
				continue;
			}

			switch (name) {
				// height sends up both dimensions
				// so width does nothing
				case "width":
					continue;
					break;

				case "height":
					let { width, height, format } = this.Data;
					if (width == null || height == null) {
						continue;
					}

					let bundle = {
						width,
						height,
						format,
						_daisy_msg_type: "resize",
					};

					DaisyMessenger.send(window.parent, bundle, "*");
					break;
			}

			this.renderedData[name] = value;
		}
	},
};


// ==============================================================================
// Resize the iframe on a width/height change
// ------------------------------------------------------------------------------

window.AdResizer = {
	init() {
		this.Dom = {};
		this.Data = {};
		this.listen();
	},

	listen() {
		DaisyMessenger.addListener("resize", (rawMessage, message) => {
			this.resize(message);
		});
	},

	getEl(format) {
		if (!this.Dom[format]) {
			this.Dom[format] = {};
			let el = jQuery(`#ad_frame_${format}`);

			if (!el.length) {
				return null;
			}

			let container = el.closest(".ad-container");
			this.Dom[format] = { el, container };
		}

		return this.Dom[format];
	},

	getDimensions(format) {
		if (this.Data[format] == null) {
			this.Data[format] = {};
		}
		return this.Data[format];
	},

	snapDimensions({ width, height }) {
		if (typeof DisplayAds === "undefined" || DisplayAds === null) {
			return { width, height };
		}

		/*
		loop through the common formats.
		if any the dimensions we get are 5px or less larger than a standard
		dimension, snap to that dimension.
		that way, we don't get any errant pixels fucking up our look.
		*/

		for (let format of Object.keys(DisplayAds.formats || {})) {
			let [widthF, heightF] = DisplayAds.formats[format];
			let widthDiff = width - widthF;

			if (5 > widthDiff && widthDiff > 0) {
				width = widthF;
			}

			let heightDiff = height - heightF;

			if (5 > heightDiff && heightDiff > 0) {
				height = heightF;
			}
		}

		return { width, height };
	},

	resize(param) {
		if (param == null) {
			param = {};
		}

		let { width, height, format } = param;

		if (!width || !height || !format) {
			return;
		}

		let { el, container } = this.getEl(format);

		if (!el.length) {
			return;
		}

		({ width, height } = this.snapDimensions({ width, height }));
		let { widthStored, heightStored } = this.getDimensions(format);

		// whenever we set a dimension, set it on the container too
		// the container should have auto left-right margins

		if (width !== widthStored) {
			el.css({ width });
			container.css({ width });
		}

		if (height !== heightStored) {
			el.css({ height });
			container.css({ height });
		}

		this.Data[format] = { width, height };
	},
};



// WEBPACK FOOTER //
// ./src/legacy/adresizer.js